import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'stock-record',
        label: 'Core',
        to: '/clearing/operations/stock-record',
      }),
    }) satisfies AggregateBreadcrumb,
});
